import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Admin } from '../models/admin/admin.model';

@Injectable({
  providedIn: 'root'
})
export class AdminService {

  apiUrl: string = "Admin";
  constructor(private http: HttpClient) { }

  getExistingUsers(accessId: number): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(accessId);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/ExitstingUsers/', body, { headers: headers }).pipe(map(result => {
      return result.body;
    }));
  }

  getAccessId(accessLevel: number, accessId: number, term: string): Observable<any> {
    let reqObject = {
      accessLevel: accessLevel,
      accessId: accessId,
      keyword: term
    };
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(reqObject);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/LoadAccessId/', body, { headers: headers }).pipe(map(result => {
      return result.body;
    }));
  }

  saveNewUser(admin: Admin): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(admin);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/AddNewUser',
      body, { headers: headers }).pipe(map(result => {
        return result.body;
      }));
  }

  getAccessIdForAdmin(accessId: number): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(accessId);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/AccessIdsForAdmin/', body, { headers: headers }).pipe(map(result => {
      return result.body;
    }));
  }

  resendWelcomeLetter(admin: Admin): Observable<any> {
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(admin);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/ResendWelcomeLetter',
      body, { headers: headers }).pipe(map(result => {
        return result.body;
      }));
  }

  validateEMail(email:string){
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(email);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/ValidateEmail',
      body, { headers: headers });
  }
  validateUserID(userID:string){
    const headers = { 'content-type': 'application/json' }
    const body = JSON.stringify(userID);
    return this.http.post<any>(environment.baseUrl + this.apiUrl + '/ValidateUserID',
      body, { headers: headers });
  }


}
